import { useEffect, useState } from "react";
import { ListingHeader } from "../../../components/listing-header";
import CourseViewer from "../../../components/designs/course-viewer";
import axiosService from "../../../core/services/axios-service";
import { ApiRoutes } from "../../../core/dictionary/api-url";
import Loader from "../../../components/designs/loader";

// Published Articulate 360 course URL — replace with the actual URL
const COURSE_URL = "/courses/code-prep-teams/scormdriver/indexAPI.html";

// Backend _id for "CodePRep™ for Coaches" — used to look up existing progress
const CODE_PREP_COACH_COURSE_ID = "69cff878b54cb88fb5c99cd9";

export default function CodePrepCoach() {
  const [courseData, setCourseData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProgress = async () => {
      setLoading(true);
      try {
        const res = await axiosService.get(ApiRoutes.ASSIGNED_COURSES_BY_USER);
        const assigned = res?.data?.data || [];
        const entry = assigned.find(
          (item) => item.course._id === CODE_PREP_COACH_COURSE_ID
        );
        setCourseData(entry || null);
      } catch {
        // If the fetch fails, still render the viewer with zero progress
        setCourseData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchProgress();
  }, []);

  return (
    <>
      <ListingHeader
        title="CodePRep™ for Coaches"
        breadCrumb={[
          { label: "Dashboard", href: "/dashboard" },
          { label: "CodePRep™ for Coaches", href: "/code-prep-coach" },
        ]}
        actions={[]}
        dropdown={null}
      />

      {loading ? (
        <div className="course-loader-wrapper">
          <Loader text="Loading course..." />
        </div>
      ) : (
        <CourseViewer
          courseId={CODE_PREP_COACH_COURSE_ID}
          courseUrl={COURSE_URL}
          courseTitle="CodePRep™ for Coaches"
          initialProgress={courseData?.coursePercentage ?? 0}
          initialLocation={courseData?.currentPage ?? ""}
        />
      )}
    </>
  );
}
